import { FC } from "react";
import { OptionProps } from "react-select";
import { Option as DropdownOption } from "../../Dropdown/components/Option";
import { OptionItem } from "../../Dropdown/OptionItem";
import { HighlightedMatches } from "./HighlightMatches";

/**
 * A single option within the select.
 */
export const Option: FC<OptionProps<OptionItem | null>> = (props) => {
  const { data, selectProps } = props;
  const { inputValue } = selectProps;
  const label = data?.label?.toString() ?? "";

  return (
    <DropdownOption {...props}>
      <HighlightedMatches text={label} query={inputValue ?? ""} />
    </DropdownOption>
  );
};
